module.exports = __webpack_public_path__ + "static/media/no-messages.42434143.png";